"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineIcon = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const isSummaryItem_1 = require("./isSummaryItem");
const getOrderLineIcon = (item) => {
    const { type } = item;
    switch (type) {
        case "FLIGHT": {
            return "https://golfsavers.b-cdn.net/assets/icons/flight_icon.png";
        }
        case "GOLF": {
            return "https://golfsavers.b-cdn.net/assets/icons/golf_icon.png";
        }
        case "TRANSFER": {
            return "https://golfsavers.b-cdn.net/assets/icons/transfer_icon.png";
        }
        case "HOTEL": {
            return "https://golfsavers.b-cdn.net/assets/icons/hotel_icon.png";
        }
        case "EXCURSION": {
            if ((0, isSummaryItem_1.isSummaryItem)(item))
                return "";
            if (!item.versions)
                return null;
            const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
            if (!latest_version)
                return null;
            const config = latest_version.config;
            switch (config?.product?.excursion?.type) {
                case "experience": {
                    return "https://golfsavers.b-cdn.net/assets/icons/experiences_icon.png";
                }
                case "attraction": {
                    return "https://golfsavers.b-cdn.net/assets/icons/attractions_icon.png";
                }
                case "tour": {
                    return "https://golfsavers.b-cdn.net/assets/icons/tours_icon.png";
                }
                case "other": {
                    return "https://golfsavers.b-cdn.net/assets/icons/other_icon.png";
                }
                default:
                    return "https://golfsavers.b-cdn.net/assets/icons/excursions_icon.png";
            }
        }
        case "CUSTOM": {
            if ((0, isSummaryItem_1.isSummaryItem)(item))
                return "";
            if (!item.versions)
                return null;
            const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
            if (!latest_version)
                return null;
            const config = latest_version.config;
            switch (config?.where_when_who?.product_type) {
                case "CUSTOM":
                    return "https://golfsavers.b-cdn.net/assets/icons/custom_icon.png";
                case "CLUB_HIRE":
                    return "https://golfsavers.b-cdn.net/assets/icons/clubhire_icon.png";
                case "TOUR_GUIDE":
                    return "https://golfsavers.b-cdn.net/assets/icons/tours_icon.png";
                default:
                    return "https://golfsavers.b-cdn.net/assets/icons/custom_icon.png";
            }
        }
    }
};
exports.getOrderLineIcon = getOrderLineIcon;
